import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { requestGet } from '../../api/request';
import { FLICKR_IMAGES_WITH_SIZE } from '../../api/url';
import VideoPlayer from './VideoPlayer';

const SwiperForEvent = (props) => {
  const { data } = props;

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const [pictureSizes, setPictureSizes] = useState(undefined);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const getImagesWithSize = async () => {
    const active = document.querySelector('.swiper-slide-active img');
    const url = active.src.split('/').pop();
    const id = url.split('_')[0];

    if (id) {
      const response = await requestGet(FLICKR_IMAGES_WITH_SIZE, {
        id,
      });

      if (response.success) {
        setPictureSizes(response.data.filter((data) => data.label === 'Small' || data.label === 'Large' || data.label === 'Original'));
      }
    }
  };

  const showOptions = () => {
    const slide = document.querySelector('.swiper-slide-active');
    const swiper = document.querySelector('.swiper');

    if (slide) {
      const options = document.querySelector('.swiper-slide-active .download_options');

      // Show download options;
      slide.addEventListener('click', (e) => {
        const { target } = e;
        if (target.closest('.download_button')) {
          if (window.getComputedStyle(options).opacity === '0') {
            options.style.opacity = '1';
          } else {
            options.style.opacity = '0';
          }
        }
      });

      // Hide download options if click somewhere else;
      swiper.addEventListener('click', (e) => {
        const { target } = e;
        if (!target.closest('.download_button')) {
          options.style.opacity = '0';
        }
      });
    }
  };

  useEffect(() => {
    if (dictionary) {
      setThumbsSwiper(null);
    }
  }, [data]);

  return (
    <>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        spaceBetween={10}
        navigation={true}
        preloadImages={false}
        onAfterInit={() => {
          getImagesWithSize();
          showOptions();
        }}
        onSlideChangeTransitionEnd={() => {
          getImagesWithSize();
          showOptions();
        }}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="swiper events-swiper2 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
      >
        {data
          .filter((t) => t.type === 'original')
          .map((value) => (
            <SwiperSlide key={value.id}>
              {value.asset_type_id === undefined ? (
                <>
                  <img
                    style={{ verticalAlign: 'baseline' }}
                    loading="lazy"
                    src={value.src}
                    alt=""
                  />
                  <div className="download_button">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                    >
                      <rect
                        width="36"
                        height="36"
                        rx="18"
                        fill="black"
                        fillOpacity="0.2"
                      />
                      <path
                        d="M27 21V25C27 25.5304 26.7893 26.0391 26.4142 26.4142C26.0391 26.7893 25.5304 27 25 27H11C10.4696 27 9.96086 26.7893 9.58579 26.4142C9.21071 26.0391 9 25.5304 9 25V21"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13 16L18 21L23 16"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18 21V9"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <div className="download_options">
                      <div className="download_options2" />
                      {pictureSizes
                        ? pictureSizes.map((data) => (
                          <a
                            key={data.width}
                            href={data.source}
                            download
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <path
                                  d="M15.75 11.75V14.75C15.75 15.1478 15.592 15.5294 15.3107 15.8107C15.0294 16.092 14.6478 16.25 14.25 16.25H3.75C3.35218 16.25 2.97064 16.092 2.68934 15.8107C2.40804 15.5294 2.25 15.1478 2.25 14.75V11.75"
                                  stroke="#3B6B3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M5.25 8L9 11.75L12.75 8"
                                  stroke="#3B6B3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M9 11.75V2.75"
                                  stroke="#3B6B3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              {dictionary[data.label]}
                            </p>
                          </a>
                        ))
                        : null}
                    </div>
                  </div>
                </>
              ) : null}
              {value.asset_type_id === 2 ? <VideoPlayer data={value} /> : null}
            </SwiperSlide>
          ))}
      </Swiper>
      {
        data.filter((t) => t.type === 'small').length > 1 ? (
          <Swiper
            onSwiper={setThumbsSwiper}
            preloadImages={false}
            spaceBetween={2}
            slidesPerView={6}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className="swiper events-swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-free-mode swiper-watch-progress swiper-backface-hidden swiper-thumbs"
          >
            {data
              .filter((t) => t.type === 'small')
              .map((value) => (
                <SwiperSlide key={value.id}>
                  {value.asset_type_id === undefined
                  || value.asset_type_id === 2 ? (
                    <img loading="lazy" src={value.src} alt="" />
                    ) : null}
                </SwiperSlide>
              ))}
          </Swiper>
        ) : null
      }
    </>
  );
};

export default SwiperForEvent;
